/* tslint:disable */
/* eslint-disable */
/**
 * MedicalOperations API
 * This is an OpenAPI for the MedicalOperations Microservice
 *
 * OpenAPI spec version: 0.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

 /**
 * 
 *
 * @export
 * @interface EditAppointmentRequest
 */
export interface EditAppointmentRequest {

    /**
     * @type {string}
     * @memberof EditAppointmentRequest
     * @example Severe Headache and Insomnia.
     */
    ConsultationReason?: string;

    /**
     * @type {string}
     * @memberof EditAppointmentRequest
     */
    Status?: EditAppointmentRequestStatusEnum;

    /**
     * @type {Date}
     * @memberof EditAppointmentRequest
     */
    DateTo?: Date;

    /**
     * @type {string}
     * @memberof EditAppointmentRequest
     * @example Patient has been referred by Dr Phil
     */
    Notes?: string;

    /**
     * @type {number}
     * @memberof EditAppointmentRequest
     * @example 8
     */
    Priority?: number;

    /**
     * @type {string}
     * @memberof EditAppointmentRequest
     * @example Waiting
     */
    CurrentStage?: string;

    /**
     * @type {Date}
     * @memberof EditAppointmentRequest
     */
    DateFrom?: Date;
}

/**
 * @export
 * @enum {string}
 */
export enum EditAppointmentRequestStatusEnum {
    PendingFollowup = 'Pending Followup',
    Missed = 'Missed',
    Canceled = 'Canceled',
    Closed = 'Closed',
    Scheduled = 'Scheduled'
}
